/* eslint-disable jsx-a11y/control-has-associated-label */

import { commonIcons } from '@apps-common/config/icons'
import { INotificationPayload } from '@apps-common/types/portal/push-registration'
import { ToastCloseTimerButton } from './ToastCloseTimerButton'

export declare type ToastType = 'info' | 'success' | 'warning' | 'error'

export interface IToastPushNotificationProps {
  payload: INotificationPayload
  icon?: any
  isPaused?: boolean
  toastProps?: any
}

export const ToastPushNotification: React.FC<IToastPushNotificationProps> = ({ payload, icon, isPaused, toastProps }) => {
  const { id, title, body, data, action } = payload
  const autoClose = toastProps?.autoClose
  // const { link } = data || {}
  // const defaultTimeout = toastProps?.autoClose || 60000

  // console.log('payload', payload)

  return (
    <div className='!bg-surface'>
      <div className='absolute top-3 right-3'>
        {typeof autoClose === 'number' && autoClose > 0 ? (
          <ToastCloseTimerButton autoClose={autoClose} paused={isPaused} onClose={() => toastProps?.closeToast()} />
        ) : (
          <button
            type='button'
            className='action-brand-solid rounded-full flex items-center justify-center !w-[24px] !h-[24px]'
            onClick={(e) => {
              e.stopPropagation()
              toastProps?.closeToast()
            }}
          >
            <commonIcons.close />
          </button>
        )}
      </div>
      <div className='pl-3 pr-[58px] pt-3 pb-2 flex flex-col items-start justify-start gap-[5px]'>
        <div className='flex items-center justify-start gap-[10px]'>
          {icon && icon}
          <p className='grow jost-medium text-[0.75rem]'>{title}</p>
        </div>
        <div className='py-1 px-2'>
          <p className='grow jost text-[0.9rem]'>{body}</p>
        </div>
      </div>
    </div>
  )
}
